const config = {
    root: '/form',
    productName: 'UXForm',
    companyName: 'UXRay',
    contactEmail: 'contact@uxray.app',
    environment: document.location.hostname === "localhost" ? 'development' : process.env.NODE_ENV
}

export default config